module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fm-title"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Main Characters")])]), _vm._v(" "), _c('p', {
    staticClass: "noindenth"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Trotsky’s Family")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("David Bronstein (1874–1922) – father")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Anna Bronstein (1850–1910) – mother")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Alexander Bronstein (1870–"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("1938")]), _vm._v(") – older brother")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Yelizaveta Bronstein (1875–1924) – older sister")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Olga Bronstein (1883–"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("1941")]), _vm._v(") – younger sister; an Oppositionist")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Aleksandra Sokolovskaya (1872–"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("1938")]), _vm._v(") – Marxist revolutionary; Trotsky’s (first) wife; an Oppositionist")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Zina Trotsky (1901–"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("33")]), _vm._v(") – elder daughter; an Oppositionist")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Nina Trotsky (1902–28) – younger daughter; an Oppositionist")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Natalya Sedova (1882–1962) – Trotsky’s (common-law) wife; an Oppositionist")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Lyova Sedov (1906–"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("38")]), _vm._v(") – elder son; an Oppositionist")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Sergei Sedov (1908–"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("37")]), _vm._v(") – younger son")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Zakhar Moglin (1897–"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("1937")]), _vm._v(") – Zina’s first husband; an Oppositionist")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Platon Volkov (1898–"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("1938")]), _vm._v(") – Zina’s second husband; an Oppositionist")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Man Nevelson (1896–"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("1937")]), _vm._v(") – Nina’s husband; an Oppositionist")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Anya Riabukhana (1899–"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("1938")]), _vm._v(") – Lyova’s wife")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Seva (Esteban) Volkov (1926–) – grandson")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Aleksandra Moglin (1923–89) – granddaughter (she met Seva – her half-brother – who travelled from Mexico to Russia just before she died; but they couldn’t communicate, as she had no Spanish or English, and he had forgotten Russian)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Lev Nevelson (1921–?) – grandson; fate unknown")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Volina Nevelson (1926–?) – granddaughter; fate unknown")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Lyulik Sedov (1926–?) – grandson; fate unknown")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Yulia Sedov-Rubinstein (1936–) – granddaughter")]), _vm._v(" "), _c('p', {
    staticClass: "noindenth"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Trotsky’s Main Supporters")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Vladimir Antonov-Ovseenko (1883–"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("1938")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Jan Frankel (1906–84)")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Joseph Hansen (1910–79)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Jean van Heijenoort (1912–86)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Adolfe Joffe (1883–"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("1927")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Rudolf Klement (1908–"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("38")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Nikolai Krestinsky (1883–"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("1938")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Anatoly Lunacharsky (1875–1933)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Raymond Molinier (1904–94)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Nikolai Muralov (1877–"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("1937")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Alexander Parvus (1867–1924)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Yevgeni Preobrazhensky (1886–"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("1937")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Georgei Pyatakov (1880–"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("1937")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Karl Radek (1885–"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("1939")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Christian Rakovsky (1873–"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("1941")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Ignaz Reiss(1899–"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("1937")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Alfred Rosmer (1877–1964)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("David Ryazanov (1870–"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("1938")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Max Schachtman (1904–72)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Ephraim Skylansky (1892–"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("1925")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Ivan Smirnov (1881–"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("1936")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Vladimir Smirnov (1887–"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("1937")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Grigori Sokolnikov (1888–"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("1939")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Moisei Uritsky (1873–1918) – Chekist; assassinated")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Erwin Wolf (1902–"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("37")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "noindenth"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Other Leading Russian Marxists")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Paul Axelrod (1850–1928) – leading member of the RSDWP; later a Menshevik")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Nikolai Bukharin (1888–"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("1938")]), _vm._v(") – leading member of the RSDWP; later a Bolshevik; later an Oppositionist")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Felix Dzershinsky (1877–1926) – Bolshevik; head of the Cheka, the GPU & then the OGPU")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Lev Kamenev (1883–"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("1936")]), _vm._v(") – leading member of the RSDWP; later a Bolshevik; one of the anti-Trotsky triumvirate; later an Oppositionist (also Trotsky’s son-in-law)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Nadezhda Krupskaya (1869–1939) – leading Bolshevik; Lenin’s wife")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Mikhail Lashevich (1884–"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("1928")]), _vm._v(") – initially a Bolshevik; later an Oppositionist")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Vladimir I. Lenin (1870–1924) – early Russian Marxist; leading member of the RSDWP; later head of the Bolsheviks")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Julius Martov (1873–1923) – leading member of the RSDWP; later Menshevik, Internationalist Menshevik")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Georgi Plekhanov (1856–1918) – early Russian Marxist; leader of the RSDWP")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Alexander Potresov (1869–1934) – leading member of the RSDWP; later a Menshevik")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Joseph Stalin (1878–1953) – Bolshevik, and one of the anti-Trotsky triumvirate")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Vera Zasulich (1851–1919) – leading member of the RSDWP; later a Menshevik")]), _vm._v(" "), _c('p', {
    staticClass: "noindentf"
  }, [_vm._v("Gregorii Zinoviev (1883–"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("1936")]), _vm._v(") – leading member of the RSDWP; later a Bolshevik; one of the anti-Trotsky triumvirate; later an Oppositionist")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21742718","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/08_Maincharacters.vue
// module id = 81
// module chunks = 0